import React, { useEffect, useState } from 'react';
import { Box, Alert, Button } from '@mui/material';
import axiosInstance from '../axiosConfig';

const EmailVerification = () => {
  const [users, setUsers] = useState([]);
  const [modifiedUsers, setModifiedUsers] = useState([]);
  const [alert, setAlert] = useState(null);
    
  useEffect(() => {
    if (alert && alert.severity !== "info") {
      const timer = setTimeout(() => {
        setAlert(null);
      }, 3000); // 3 Sekunden Timeout
  
      return () => clearTimeout(timer); // Cleanup-Funktion für den Timer
    }
  }, [alert]);

  useEffect(() => {
    const fetchUsers = async () => {
      const token = localStorage.getItem('authToken');
      const response = await axiosInstance.get('/admin/users', {
        headers: {
          Authorization: `${token}`,
        },
      });
      setUsers(response.data);
    };
    fetchUsers();
  }, []);

  const handleVerificationChange = (index, isVerified) => {
    const updatedUsers = [...users];
    updatedUsers[index].isVerified = isVerified;
    setUsers(updatedUsers);

    if (!modifiedUsers.find((user) => user._id === updatedUsers[index]._id)) {
      setModifiedUsers([...modifiedUsers, updatedUsers[index]]);
    }
  };

  const handleSubmitChanges = async () => {
    const token = localStorage.getItem('authToken');
    try {
      const response = await axiosInstance.put('/admin/users/update', modifiedUsers, {
        headers: {
          Authorization: `${token}`,
        },
      });
      if (response.status === 200) {
        setAlert({
          severity: "success",
          message: "Änderungen erfolgreich übernommen."
        });
      }
    } catch (error) {
      setAlert({
        severity: "error",
        message: "Fehler beim Übernehmen der Änderungen. Bitte versuchen Sie es erneut."
      });
    }
  };

  return (
    <Box sx={{ ml: '1rem', mr: '1rem'}}>
      {alert && (
        <Box sx={{ marginTop: '1rem'}}>
          <Alert severity={alert.severity}>
            {alert.message}
          </Alert>
        </Box>
      )}
      <table>
        <thead>
          <tr>
            <th>Name</th>
            <th>E-Mail</th>
            <th>E-Mail verifiziert</th>
          </tr>
        </thead>
        <tbody>
          {users.map((user, index) => (
            <tr key={user._id}>
              <td>{user.name}</td>
              <td>{user.email}</td>
              <td>
                <input
                  type="checkbox"
                  checked={user.isVerified}
                  onChange={(e) => handleVerificationChange(index, e.target.checked)}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <Button variant="contained" size="small" color="primary" onClick={handleSubmitChanges} sx={{ mb: 2, bgcolor: 'primary.light', '&:hover': { color: '#fff' } }} type="button">
        Änderungen übernehmen
      </Button>
    </Box>
  );
};

export default EmailVerification;
